export const jobsRoutes = {
  jobs: `/jobs`,
  internalRoutes: {
    active: 'active',
    completed: 'completed',
    requestService: 'request-service',
  },
} as const;
